import { push } from "connected-react-router";
import ReactDOM from "react-dom";

import StopHoverCard from "react/components/RouteProgress/StopHoverCard/StopHoverCard"

App.Views.RouteProgress = {

    createLabels: function () {

        var tab = document.getElementById('RouteProgress');
        var gridContainer = document.querySelector('.RouteProgressGridContainer');

        var labelContainer = document.createElement('div');
        labelContainer.className = 'RouteProgressLabelContainer';

        //onTimeLabel
        var onTimeLabel = document.createElement('div');
        var onTimeColor = document.createElement('div');
        var onTimeText = document.createElement('div');

        onTimeLabel.className = 'TimeSliceLabel';

        onTimeColor.className = 'RouteProgressOnTime';
        onTimeText.innerHTML = Monet.I18n.getResourcesByKey('RouteProgress.StopStatus.OnTime');

        onTimeLabel.appendChild(onTimeColor);
        onTimeLabel.appendChild(onTimeText);

        labelContainer.appendChild(onTimeLabel);

        //lateTimeWindow
        var lateLabel = document.createElement('div');
        var lateColor = document.createElement('div');
        var lateText = document.createElement('div');

        lateLabel.className = 'TimeSliceLabel';

        lateColor.className = 'RouteProgressLate';
        lateText.innerHTML = Monet.I18n.getResourcesByKey('RouteProgress.StopStatus.LateTW');

        lateLabel.appendChild(lateColor);
        lateLabel.appendChild(lateText);

        labelContainer.appendChild(lateLabel);

        //EarlyTimeWindow
        var earlyLabel = document.createElement('div');
        var earlyColor = document.createElement('div');
        var earlyText = document.createElement('div');

        earlyLabel.className = 'TimeSliceLabel';

        earlyColor.className = 'RouteProgressEarly';
        earlyText.innerHTML = Monet.I18n.getResourcesByKey('RouteProgress.StopStatus.EarlyTW');

        earlyLabel.appendChild(earlyColor);
        earlyLabel.appendChild(earlyText);

        labelContainer.appendChild(earlyLabel);

        /* offDays */

        //onTimeLabel
        var onTimeOffDayLabel = document.createElement('div');
        var onTimeOffDayColor = document.createElement('div');
        var onTimeOffDayText = document.createElement('div');

        onTimeOffDayLabel.className = 'TimeSliceLabel ';

        onTimeOffDayColor.className = 'RouteProgressOnTime onTimeOffDay';
        onTimeOffDayText.innerHTML = Monet.I18n.getResourcesByKey('RouteProgress.StopStatus.OnTimeOffDay');

        onTimeOffDayLabel.appendChild(onTimeOffDayColor);
        onTimeOffDayLabel.appendChild(onTimeOffDayText);

        labelContainer.appendChild(onTimeOffDayLabel);

        //lateTimeWindow
        var lateOffDayLabel = document.createElement('div');
        var lateOffDayColor = document.createElement('div');
        var lateOffDayText = document.createElement('div');

        lateOffDayLabel.className = 'TimeSliceLabel';

        lateOffDayColor.className = 'RouteProgressLate lateOffDay';
        lateOffDayText.innerHTML = Monet.I18n.getResourcesByKey('RouteProgress.StopStatus.LateOffDayTW');

        lateOffDayLabel.appendChild(lateOffDayColor);
        lateOffDayLabel.appendChild(lateOffDayText);

        labelContainer.appendChild(lateOffDayLabel);

        //EarlyTimeWindow
        var earlyOffDayLabel = document.createElement('div');
        var earlyOffDayColor = document.createElement('div');
        var earlyOffDayText = document.createElement('div');

        earlyOffDayLabel.className = 'TimeSliceLabel';

        earlyOffDayColor.className = 'RouteProgressEarly earlyOffDay';
        earlyOffDayText.innerHTML = Monet.I18n.getResourcesByKey('RouteProgress.StopStatus.EarlyOffDayTW');

        earlyOffDayLabel.appendChild(earlyOffDayColor);
        earlyOffDayLabel.appendChild(earlyOffDayText);

        labelContainer.appendChild(earlyOffDayLabel);

        /* offDays */

        // Canceled Pending Labels
        var canceledLabel = document.createElement('div');
        var canceledColor = document.createElement('div');
        var canceledText = document.createElement('div');

        canceledLabel.className = 'TimeSliceLabel';

        canceledColor.className = 'CanceledStop';
        canceledText.innerHTML = Monet.I18n.getResourcesByKey('RouteProgress.StopStatus.Canceled');

        canceledLabel.appendChild(canceledColor);
        canceledLabel.appendChild(canceledText);

        labelContainer.appendChild(canceledLabel);

        gridContainer.style.height = 'auto';

        // Done Pending Labels
        var pedingLabel = document.createElement('div');
        var pedingColor = document.createElement('div');
        var pedingText = document.createElement('div');

        pedingLabel.className = 'TimeSliceLabel';

        pedingColor.className = 'PendingStop';
        pedingText.innerHTML = Monet.I18n.getResourcesByKey('RouteProgress.StopStatus.Pending');

        pedingLabel.appendChild(pedingColor);
        pedingLabel.appendChild(pedingText);

        labelContainer.appendChild(pedingLabel);

        tab.appendChild(labelContainer);


    },

    toggleCurrentTime: ({ isChecked }) => {
      const currentTimeEl = document.querySelectorAll('.RouteProgressGridContainer div.RouteProgressCurrentTime');

      currentTimeEl?.forEach?.((el) => {
        if (isChecked) {
          el.style.display = 'block';
        } else {
          el.style.display = 'none';
        }
      })
    },

    createFilters: function () {

        const projectionBuilder = new Monet.Builder.Projection();

        const fields = App.Forms.RouteProgress.fields;
        const fieldsList = ["route.id", "primaryEquipment.id", "primaryEquipment.key", "primaryEquipment.equipmentType.size1", "primaryEquipment.equipmentType.size2", "primaryEquipment.equipmentType.size3", "route.actualSize1", "route.actualSize2", "route.actualSize3", "route.baselineSize1", "route.baselineSize2", "route.baselineSize3", "route.plannedSize1", "route.plannedSize2", "route.plannedSize3", "route.actualPickupSize1", "route.actualPickupSize2", "route.actualPickupSize3", "route.baselinePickupSize1", "route.baselinePickupSize2", "route.baselinePickupSize3", "route.plannedPickupSize1", "route.plannedPickupSize2", "route.plannedPickupSize3", "primaryDriver.name", "route.date", "route.plannedCost", "route.baseLineCost", "route.actualCost", "route.key", "route.actualDepartures", "route.status", "route.actualStart", "route.actualDeparture", "route.projectedComplete", "route.totalStops", "route.redeliveredStops", "route.canceledStops", "route.undeliveredStops", "route.description", "route.stops.id", "route.stops.location.description", "route.stops.baseLineArrival", "route.stops.actualArrival", "route.stops.actualDeparture", "route.stops.plannedArrival", "route.stops.projectedArrival", "route.stops.baseLineService", "route.stops.plannedService", "route.stops.projectedService", "route.stops.baseLineDeparture", "route.stops.plannedDeparture", "route.stops.projectedDeparture", "route.stops.location.deliveryDays", "route.stops.location.key", "route.stops.location.locationOverrideTimeWindows.*", "route.stops.plannedSize1", "route.stops.plannedSize2", "route.stops.plannedSize3", "route.stops.actualSize1", "route.stops.actualSize2", "route.stops.actualSize3", "route.stops.cancelCode.id", "route.driverAssignments.*", "route.equipmentAssignments.*", "route.driverAssignments.driver.id", "route.driverAssignments.driver.name", "route.equipmentAssignments.equipment.id", "route.equipmentAssignments.equipment.key", "route.equipmentAssignments.equipment.description", "route.stops.location.timeWindowType.id", "route.stops.location.timeWindowType.timeWindowTypeDays.*", "organization.description", "routePercentage", "stopView", "route.stops.deliveryStatus"];

        const fieldListArrayObjects = [];

        for (let key in fieldsList) {
            fieldListArrayObjects.push({
                name: fieldsList[key]
            });
        }

        for (let key2 in fields) {
            fieldListArrayObjects.push(fields[key2]);
        }

        projectionBuilder.addFields(fieldListArrayObjects);

        App.Forms.RouteProgress.pagination.max = 51;

        projectionBuilder.projection.pagination = App.Forms.RouteProgress.pagination;

        const projection = projectionBuilder.projection.toString();

        const fb = new Monet.UI.FilterBuilder();
        fb.setUrl('/Progress');
        fb.setGenerateTimeRange(false);
        fb.setEntity('RouteView');
        fb.setSelector('.RouteProgressGridContainer');
        fb.setCustomNameSpace('RouteProgress');
        fb.getFieldList();
        fb.setProjection(projection);
        fb.setDefaultFilters({
            'route.date': { value: Monet.Format.Date.getTodayISOString() }
        });
        fb.render();
        fb.setCallbacks({
            success: function (data) {
              const request = new Greenmile.RouteProgress.Request();
              request.filter(data);
            },
            error: this.filterErrorCallback,
            beforeFilter: function () {
                App.Forms.RouteProgress.canUpdate = false;
            }

        });

        const container = document.querySelector("#RouteProgress .gridActions");
        container.appendChild(fb.el);

        App.Forms.RouteProgress.filterBuilder = fb;

        // create checkbox to lock todayBar
        //
        const containerBoxLockPosition = document.createElement('div');
        const checkBoxLockPosition = document.createElement('input');
        const checkBoxLockPositionLabel = document.createElement('label');
        const monetUIFilterBuilderFilterButtonContainer = document
          .querySelector('#RouteProgress .MonetUIFilterBuilderFilterButtonContainer');

        const lockPositionCallback = (e) => {
          this.toggleCurrentTime({
            isChecked: e?.target?.checked
          });
        };

        containerBoxLockPosition.className = 'checkboxLockPositionContainer';
        checkBoxLockPosition.type = 'checkbox';
        checkBoxLockPosition.id = 'checkBoxLockPosition';
        checkBoxLockPosition.checked = true;
        checkBoxLockPosition.removeEventListener('click', lockPositionCallback);
        checkBoxLockPosition.addEventListener('click', lockPositionCallback);

        checkBoxLockPositionLabel.innerHTML = Monet.I18n.getResourcesByKey('RouteProgress.LockTodayBar.Label');
        checkBoxLockPositionLabel.htmlFor = checkBoxLockPosition.id;

        containerBoxLockPosition.appendChild(checkBoxLockPosition);
        containerBoxLockPosition.appendChild(checkBoxLockPositionLabel);
        monetUIFilterBuilderFilterButtonContainer.appendChild(containerBoxLockPosition);

        fb.adjustHeaderSize();
        fb.renderSpecialSelect();
        fb.executeFilter();

    },

    filterErrorCallback: function (e) {
        console.log(e);
    },

    createGrid: function (callback) {
        let bound;
        let columns;
        const data = Greenmile.RouteProgress.data;
        const utils = new Greenmile.RouteProgress.Utils();
        const grid = new Greenmile.RouteProgress.Grid();
        const routes = utils.setDataToCollection(data);
        const lockPosition = document.querySelector('#RouteProgress #checkBoxLockPosition');
        const defaultColumns = Greenmile.RouteProgress.StaticData.defaultColumns();
        const pagination = App.Forms.RouteProgress.pagination;

        Greenmile.RouteProgress.StaticData.columns = [];

        if (!App.Forms.RouteProgress.FloatMenu) {
            App.Forms.RouteProgress.FloatMenu = null;
        }

        for (let i = 0, l = defaultColumns.length; i < l; i++) {
            Greenmile.RouteProgress.StaticData.columns.push(defaultColumns[i]);
        }

        let previousRoutes = App.Forms.RouteProgress.dataProvider.getItems();

        if (previousRoutes && pagination.first !== 0) {

            let previousRoutesLength = previousRoutes.length;

            for (let j = 0; j < previousRoutesLength; j++) {

                let previousRoute = previousRoutes[j];
                let modelExists = routes.getById(previousRoute.model.get('id'));

                if (!modelExists) {
                    routes.add(previousRoute.model);
                }

            }

        } else if (previousRoutes) {
            App.Forms.RouteProgress.controlUpdater.resetPages();
        }

        bound = utils.getTimeBound(routes);

        columns = grid.generateTimeColumns(bound);

        grid.transformAllDataInGant(routes);

        Greenmile.RouteProgress.StaticData.columns.push(columns[0]);

        App.Forms.RouteProgress.table.setColumns(Greenmile.RouteProgress.StaticData.columns);

        if (callback) {
            callback('RouteProgress', Greenmile.RouteProgress.StaticData.columns, routes, true);
        }

        const routeProgressRow = document.querySelector('#RouteProgress .slick-viewport.slick-viewport-top.slick-viewport-right');

        if (lockPosition.checked) {
            const actualTimeHighlighterElement =  document.querySelector('#form_and_grid .RouteProgressCurrentTime');
            const progressGridScroll = actualTimeHighlighterElement ? (actualTimeHighlighterElement.offsetLeft - 5) : 0;

            if(routeProgressRow.scrollWidth < progressGridScroll) {
                routeProgressRow.scrollLeft = 0;
            } else {
                routeProgressRow.scrollLeft = progressGridScroll;
            }
        } else {
          this.toggleCurrentTime({ isChecked: false });
        }

        App.Forms.RouteProgress.canUpdate = true;


    },

    goToRouteDetails: function (routeId, stopId) {
      window.globalStore.dispatch(push(`/maps/route/${routeId}/details/stop/${stopId}`));
      this.mouseOutSlice();
    },

    showInfo: function (element, event) {
      function getContainer() {
        let container = document.querySelector('#RouteProgress #StopHover');

        if (!container) {
          container = document.createElement('div');
          container.id = 'StopHover';

          document.querySelector('#RouteProgress').appendChild(container);
        }
        return container;
      }

      const stopData = JSON.parse(element.getAttribute('data-hover'));
      const frozenColumnsWidth =
        document
          .querySelector('.slick-pane.slick-pane-header.slick-pane-left')
          ?.clientWidth;

      ReactDOM.render(
        <StopHoverCard
          stopData={stopData}
          boundStop={{ x: event.x, y: event.y }}
          frozenColumnsWidth={frozenColumnsWidth}
        />,
        getContainer(),
      );
    },

    mouseOutSlice: function () {
      ReactDOM.unmountComponentAtNode(
        document.querySelector('#RouteProgress #StopHover')
      );
    },
};
